<template>
  <div>
    <div class="side-frame-success">
      <span style="font-size: 14px; color: #606266">{{
        $l('INDEX.table_label_product_information') || '产品信息'
      }}</span>
      <!-- <el-divider direction="vertical"></el-divider> -->
    </div>
    <!-- <b-button
      class="mr-2"
      size="sm"
      variant="outline-success"
      @click="$emit('showDialog')"
      :disabled="disabled"
    >
      {{ $l('INDEX.btn_add') || '添加' }}
    </b-button> -->
  </div>
</template>
<script>
export default {
  props: { disabled: { type: Boolean, default: false } },
}
</script>
